import React from "react";
import { Route, Switch } from "react-router-dom";
import { TransferList } from "./TransferList";
import TransferView from "./TransferView";

export default () => {
  return {
    routes: [
      {
        path: "/bosch-transfers",
        render: ({ match }) => (
          <Switch>
            <Route path={`${match.url}`} exact component={TransferList} />
            <Route path={`${match.url}/:id`} exact>
              {(props) => <TransferView {...props} />}
            </Route>
          </Switch>
        ),
      },
    ],
  };
};
